module.exports = __webpack_public_path__ + "img/games.31fc61c1.svg";